<script lang="ts">
    import { floatingUiComponents } from "../../Utils/svelte-floatingui-show";

    interface Props {
        [key: string]: unknown;
    }

    let { ...rest }: Props = $props();
</script>

{#each [...$floatingUiComponents.entries()] as [key, value] (`${key}`)}
    {@const valueProps = value.props ?? {}}
    {@const Component = value.componentType}
    {@const action = value.action}
    {@const arrowAction = value.arrowAction}
    <div
        class="nutrivera-floating-surface absolute z-[3000] rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)]"
        style:z-index={value.zIndex}
        use:action
    >
        {#if arrowAction}
            <div use:arrowAction></div>
        {/if}
        <Component {...rest} {...valueProps} />
    </div>
{/each}
